import axios, { AxiosInstance, AxiosRequestConfig } from 'axios'
import sharedConfig from '../config'
import { HttpResultDto } from '../types/http'
import { setRequestSign } from '../helper/requestSign'
import { ResultEnum } from '../enums'
import { HttpServerError } from './error'

// 定义一个新的实例类型，它的请求方法直接返回响应数据而不是整个响应对象
export interface CustomAxiosInstance extends Omit<AxiosInstance, 'get' | 'post' | 'put' | 'delete'> {
  request<T = any, R = T>(config: AxiosRequestConfig): Promise<R>
  get<T = any, R = T>(url: string, config?: AxiosRequestConfig): Promise<R>
  post<T = any, R = T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R>
  put<T = any, R = T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<R>
  delete<T = any, R = T>(url: string, config?: AxiosRequestConfig): Promise<R>
}

/** 创建请求实例 */
export function createService(axiosConfig = {}) {
  const defaultConfig = {
    headers: { 'Content-Type': 'application/json' },
    timeout: 30000,
  }

  Object.assign(defaultConfig, axiosConfig)
  // 创建一个 axios 实例命名为 service
  const service = axios.create(defaultConfig) as CustomAxiosInstance

  // 请求拦截
  service.interceptors.request.use(
    async (config) => {
      console.debug('secret :>> ', sharedConfig.secret)

      if (sharedConfig.secret) {
        await setRequestSign(config, sharedConfig.secret)
      }

      if (config.baseURL === sharedConfig.httpPublishUrl && sharedConfig.clientId) {
        config.headers['client-id'] = sharedConfig.clientId
      }

      return config
    },
    // 发送失败
    (error) => Promise.reject(error)
  )
  // 响应拦截（可根据具体业务作出相应的调整）
  service.interceptors.response.use(
    (response) => {
      const { data } = response

      if (data.code !== ResultEnum.SUCCESS) {
        return Promise.reject(new HttpServerError(data.message, data.code))
      }

      return data.data
    },
    (error) => {
      console.error('error :>> ', error)
      return Promise.reject(error)
    }
  )
  return service
}
